import { render, staticRenderFns } from "./LifeExperiences.vue?vue&type=template&id=8dc460da&scoped=true&"
import script from "./LifeExperiences.vue?vue&type=script&lang=js&"
export * from "./LifeExperiences.vue?vue&type=script&lang=js&"
import style0 from "./LifeExperiences.vue?vue&type=style&index=0&id=8dc460da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc460da",
  null
  
)

export default component.exports